module.exports = __webpack_public_path__ + "img/66_7.26ad5ccd.png";